/* MUI */
import { CircularProgress } from '@mui/material';

/*  Shared  */
import { useFetchTenantIdentifiers } from 'hooks/dataAccess/TenantIdentifier/tenantIdentifier';
import React, { useEffect, useState } from 'react';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

const defaultSetSite = () => {};

export const SitePicker = ({
    clientId,
    type,
    disabled,
    setSite = defaultSetSite,
    ...props
}) => {
    const [selectedValue, setSelectedValue] = useState(['0']);

    const { subscriberSites, loading } = useFetchTenantIdentifiers({
        clientId,
        type
    });
    const [objectPayload, setObjectPayload] = useState(subscriberSites);

    useEffect(() => {
        setObjectPayload(subscriberSites);
    }, [subscriberSites]);

    useEffect(() => {
        if (objectPayload.length > 0 && objectPayload[0].id) {
            setSelectedValue([objectPayload[0].siteID]);
            setSite(objectPayload[0]);
        } else {
            setSelectedValue(['0']);
            setSite('0');
        }
    }, [objectPayload, setSelectedValue, setSite]);

    const exists = objectPayload[0]?.id;

    if (loading) {
        return <CircularProgress />;
    }

    return (
        <ObjectPicker
            data-testid="sitePickerObjectPicker"
            {...props}
            loaded={!loading}
            disabled={disabled || !!exists}
            objectKey="siteID"
            objectPayload={objectPayload}
            objectNameField="name"
            selectedValue={selectedValue}
            value={selectedValue}
            visualOnlyDefault={undefined}
        />
    );
};
